

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import moment from "moment";
import { HogarObservacion } from '../../models/hogar/alertas.model';
import Helpers from '../../helpers/helper';
@Component
export default class HogarObservacionesTable extends GenericBTable<
  HogarObservacion
> {
  @Prop() public title!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public hogarId!: string;
  created() {
    this.setupTable();
  }
  setupTable() {
    this.tableConfig.controller = this.controller || "hogarobservacion";
    //this.tableConfig.loading = false;
    this.tableConfig.whereParams = this.getWhereParams();
    //this.tableConfig.resource = "alertas";
    this.tableConfig.activeActions = false;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.rowClass = (row: HogarObservacion, index: number) => row.vigente && "is-warning";
    this.formatColumns();
  }
  getWhereParams() {
    let result = [];
    if (this.hogarId) result.push(`hogarId="${this.hogarId}"`);
    return result.join("&");
  }
onLoadData(response:any){
  this.$emit('vigentes', this.vigentes)
}
  get vigentes(){
    return this.tableConfig.data.filter(x=> x.vigente).length;
  }
  formatColumns() {
    let causaObservacion = new BTableColumn("causaObservacion", "Causa");
    let estado = new BTableColumn("estado", "Estado");
    let institucion = new BTableColumn("institucion", "Institución");
    let fechaObservacion = new BTableColumn("fechaObservacion", "Fecha");
    fechaObservacion.type = BTableColumnType.Date;
    let fin = new BTableColumn("fechaLiberacion", "Fecha de liberación");
   fin.type = BTableColumnType.Date;
    this.tableConfig.insertColumns(causaObservacion, estado, institucion,fechaObservacion,fin);
  }
  @Watch("hogarId", { immediate: true })
  onhogarIdChange(value: number | undefined | null) {
    if (!value) {
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();
    if (this.tableConfig.reload) this.tableConfig.reload();
  }
}
